import type { Company, CompanyForFormSubmit, CompanyForList } from 'types'
import { getPhoneNumber, statusFilter, blobToFile } from 'helpers/common'

export const formatForm = (
  data: CompanyForFormSubmit,
): CompanyForFormSubmit => {
  const nextData: CompanyForFormSubmit = data

  delete nextData.currentState
  delete nextData.code
  if (!nextData.phoneNumber) {
    delete nextData.countryCode
    delete nextData.phoneNumber
  }

  const phoneNumber = `${nextData.phoneNumber}`
  const params = {
    ...nextData,
    name: nextData.name.trim(),
    address: nextData.address.trim(),
    detail: nextData.detail?.trim(),
    ...(nextData.logo &&
      typeof nextData.logo !== 'string' && {
        logo: blobToFile(nextData.logo, 'logo.jpg'),
      }),
    ...(nextData.phoneNumber &&
      typeof phoneNumber !== undefined && {
        phoneNumber,
      }),
  }

  return params
}

export const formatList = (
  companies: Company[],
  numberStart: number,
): CompanyForList[] => {
  const nextCompanies = companies.map((company, incrementor) => ({
    ...company,
    no: (numberStart + incrementor).toString().padStart(2, '0'),
    statusReadable: statusFilter(company.isActive),
    phone: getPhoneNumber(company.contacts),
  }))

  return nextCompanies
}
